import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Totes_ds_container_typesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, ContainerTypeCategories?: number, Description?: string, Height?: number, Length?: number, Name?: string, VolumeCapacity?: number, Weight?: number, WeightCapacity?: number, Width?: number, VolumeUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, DimensionUom?: { Name?: string, Short_name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_container_types/get`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeCategories?: number, Description?: string, Height?: number, Length?: number, Name?: string, VolumeCapacity?: number, Weight?: number, WeightCapacity?: number, Width?: number, VolumeUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, DimensionUom?: { Name?: string, Short_name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_container_types/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, ContainerTypeCategories?: number, Description?: string, Height?: number, Length?: number, Name?: string, VolumeCapacity?: number, Weight?: number, WeightCapacity?: number, Width?: number, VolumeUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, DimensionUom?: { Name?: string, Short_name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_container_types/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
